"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCommunityMatrimonialRegime = void 0;
const EMaritalStatus_1 = require("../enums/ClientSheet/EMaritalStatus");
const EMatrimonialRegime_1 = require("../enums/ClientSheet/EMatrimonialRegime");
const COMMUNITY_REGIMES = [
    EMatrimonialRegime_1.EMatrimonialRegime.communaute_meuble_et_acquets,
    EMatrimonialRegime_1.EMatrimonialRegime.communaute_reduite_aux_acquets,
    EMatrimonialRegime_1.EMatrimonialRegime.communaute_universelle,
];
function isCommunityMatrimonialRegime(subscriber) {
    if (!subscriber?.matrimonialRegime)
        return false;
    const isPacsIndivision = subscriber.matrimonialRegime === EMatrimonialRegime_1.EMatrimonialRegime.indivision && subscriber.maritalStatus === EMaritalStatus_1.EMaritalStatus.pacse;
    return COMMUNITY_REGIMES.includes(subscriber.matrimonialRegime) || isPacsIndivision;
}
exports.isCommunityMatrimonialRegime = isCommunityMatrimonialRegime;
